export default __webpack_public_path__ + "view-support-card@2x.dfd5a1e.jpg";